import { IconButton, Modal, Stack } from '@mui/material';
import { Close } from 'mdi-material-ui';
import { VigoTypography } from 'src/@vigo/vigo-typography';
import { VigoFileViewer } from './VigoFileViewer';

interface PreviewModalProps {
  file: any;
  fileViewerOpen: boolean;
  closeFileViewer: () => void;
}

const PreviewModal = ({ file, fileViewerOpen, closeFileViewer }: PreviewModalProps) => {
  if (!file) return null;

  const fileName = file.name ?? file.fileName ?? '';

  return (
    <Modal open={fileViewerOpen} onClose={closeFileViewer} aria-label={fileName}>
      <Stack
        sx={{
          width: '100%',
          maxWidth: '1100px',
          height: '90vh',
          overflow: 'hidden',
          outline: 'none',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          border: theme => `1px solid ${theme.palette.divider}`,
          borderRadius: 1,
          boxShadow: 24
        }}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="center"
          sx={{
            position: 'relative',
            py: 3,
            px: 14,
            borderBottom: theme => `1px solid ${theme.palette.divider}`
          }}>
          <VigoTypography value={fileName} variant="subtitle1" noWrap disableTranslation sx={{ fontWeight: 600 }} />
          <IconButton
            onClick={closeFileViewer}
            aria-label="close"
            sx={{
              position: 'absolute',
              right: 8,
              '&:hover': { borderRadius: '4px', backgroundColor: '#626679', color: '#fff' }
            }}>
            <Close />
          </IconButton>
        </Stack>
        <VigoFileViewer file={file} />
      </Stack>
    </Modal>
  );
};

export default PreviewModal;
